<template>
    <app-container class="photo-wall-page">
        <photo-wall-header :total="total"/>
        <div class="photo-wall-page__photo-list" v-if="list.length">
            <photo-card v-for="item in list"
                        :key="item.id"
                        :data="item"
                        @click="handleClick"/>
        </div>
        <photo-wall-skeleton v-else/>
        <div class="timeline-page__loading"
             v-observe-visibility="{
                      callback: handleLoadList,
                      throttle: 250
            }">
            <app-button class="timeline-page__load-more"
                        v-if="showLoadMore"
                        @click="handleLoadList(true,true)">
                加载更多
                <app-icon value="icon-enter"/>
            </app-button>
            <app-loading v-if="loading"/>
        </div>
        <app-drawer :visible="visible" @click="handleClose">
            <template v-if="id">
                <travels-post-view :id="id"/>
            </template>
        </app-drawer>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import PhotoCard from './components/PhotoCard'
    import AppDrawer from '@components/AppDrawer'
    import AppButton from '@components/AppButton'
    import AppLoading from '@components/AppLoading'
    import AppIcon from '@components/AppIcon'
    import PhotoWallSkeleton from '@assets/svg/inline.photo-wall-skeleton.svg'
    
    import TravelsPostView from './components/TravelsPostView'
    import PhotoWallHeader from './components/PhotoWallHeader'
    
    
    import getTimelineService from '@service/getTimelineService'
    import {DEFAULT_LIMIT, TRAVEL_TAG_ID} from '@config'
    
    export default {
        name: "PhotoWall",
        data() {
            return {
                visible: false,
                id: '',
                loading: false,
                error: false,
                limit: DEFAULT_LIMIT,
                index: 0,
                total: 0,
                list: []
            }
        },
        computed: {
            showLoadMore() {
                const {loading, error, limit, index, total} = this
                if (index === 0) {
                    return (total === 0 && !loading && error)
                } else {
                    const current = (index + 1) * limit
                    // 当前数量小于分页数量，并且错误 并且不在加载中
                    return ((current < total) && !loading && error)
                }
                // !loading&&error
            }
        },
        watch: {
            id(id) {
                this.$router.replace({
                    name: this.$route.name,
                    query: {
                        id
                    }
                })
            }
        },
        mounted() {
            if (this.handleInit()) {
                this.getTimeline()
            }
        },
        methods: {
            handleInit() {
                const {id} = this.$route.query
                let flag = true
                if (id) {
                    flag = false
                    this.$router.replace({
                        name: 'blog',
                        params: {
                            id
                        },
                        query: {
                            from: this.$route.path
                        }
                    })
                }
                return flag
            },
            handleClick(data) {
                this.id = data.id
                this.visible = true
            },
            handleClose() {
                this.id = ''
                this.visible = false
            },
            async getTimeline(index = 0) {
                try {
                    this.loading = true
                    const {limit} = this
                    const {data, limit: dataLimit, total, index: dataIndex} = await getTimelineService({
                        tagId: TRAVEL_TAG_ID,
                        index,
                        limit
                    })
                    this.total = total
                    this.limit = dataLimit
                    this.index = dataIndex
                    this.list = data
                    this.error = false
                } catch (e) {
                    this.error = true
                } finally {
                    this.loading = false
                }
            },
            handleLoadList(isVisible, flag) {
                const {loading} = this
                if (isVisible && !loading) {
                    const {index, limit, total} = this
                    if ((((index + 1) * limit) < total) || flag === true) {
                        this.getTimeline(index + 1)
                    }
                    
                }
            },
        },
        components: {
            TravelsPostView,
            AppContainer,
            AppDrawer,
            PhotoCard,
            PhotoWallHeader,
            AppButton,
            AppLoading,
            AppIcon,
            PhotoWallSkeleton
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    
    .photo-wall-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        
        &__photo-list {
            columns: 1; // 默认列数
            column-gap: $paddingSP;; // 列间距
        }
        
        .photo-card {
            break-inside: avoid;
        }
    }
    
    
    @media (min-width: 640px) {
        .photo-wall-page {
            &__photo-list {
                columns: 1; // 默认列数
            }
        }
        
    }
    
    @media (min-width: 768px) {
        .photo-wall-page {
            &__photo-list {
                columns: 2; // 默认列数
            }
        }
        
    }
    
    @media (min-width: 1024px) {
        .photo-wall-page {
            &__photo-list {
                columns: 3; // 默认列数
            }
        }
        
    }

</style>